import hostConf from '$config/frontend'

export const openAlphaSchool = () => {
  window.open(`${hostConf.LANDING_PAGE}/`, '_blank')
}
